import "./ListCourses.css";
import React from "react";
import Button from "react-bootstrap/Button";
import { GoPrimitiveDot } from "react-icons/go";
import { RiEdit2Fill } from "react-icons/ri";
import { AiFillDelete} from "react-icons/ai";
import { BsFillPlayBtnFill} from "react-icons/bs";
import { GrValidate} from "react-icons/gr";
import { ImBlocked} from "react-icons/im";
import { TiArrowSync} from "react-icons/ti";
import programmation from "../../Assets/programmation.jpg";
import design from "../../Assets/design.png";
import gestionProjet from "../../Assets/gestionProjet.jpg";
import digital from "../../Assets/digital.png";
import { Link } from "react-router-dom";

import { INFO_COURS, MODIFIER_COURS_NAVIGATION } from "../../Routes/NAVIGATION_PATH";
import { updateOnFalse, updateOnTrue, deleteElement, forNotification } from "../../Firebase";
import { SamaDate } from "../../Services";

function ListCourses({ item }) {

  let couleur = item?.isArchived === false ? item?.isApproved === true ? "green" : "orange" : "red";
  let contenu = item?.isArchived === false ? item?.isApproved === true ? "Approuvé" : "En attente" : "Rejeté";



  const Affiche = (domaine) => {
    if (domaine?.toLowerCase() === "programmation") {
      return <img src={programmation} alt="images" className="mab p-2" />;
    } else if (domaine?.toLowerCase() === "design") {
      return <img src={design} alt="images" className="mab p-2" />;
    } else if (domaine?.toLowerCase() === "gestion de projet") {
      return <img src={gestionProjet} alt="images" className="mab p-2" />;
    } else if (domaine?.toLowerCase() === "marketing digital") {
      return <img src={digital} alt="images" className="mab p-2" />;
    }
  };

  const currentUserData = JSON.parse(sessionStorage.getItem("user"));

  return (
    <tr>
      <td className="d-flex justify-center align-items-center listCours p-2 ">
        <div className="container-im">{Affiche(item?.domaine)}</div>
        <div>
          <span className="fw-bold text-uppercase">{item?.titre_cours}</span>
          <br />
          <span className="te">{item?.description}</span>
          <br />
          <span className="text-muted">
            Ajouté le {<SamaDate mydate={item?.created_on} />}
          </span>
          <br />
          <span className="text-capitalize">Par {item?.infoUser}</span>
          <br />
        </div>
      </td>
      <td className=" p-3 ">
        <GoPrimitiveDot style={{ color: `${couleur}` }} />
        {contenu}
      </td>
      <td className="my-tr-cours-table">
        {currentUserData.user_type === "admin" ? (
          <>
            {item?.isApproved === false ? (
              <>
                <Button
                  onClick={() =>
                    updateOnTrue(
                      "cours",
                      item?.id,
                      "isApproved",
                      "Approuvé avec succès"
                    ).then(
                      forNotification(
                        `Le cours dont le titre est ${item?.titre_cours} a été approuvé`,
                        item?.created_by
                      ))
                  }
                  className='text-white'
                  variant="success"
                >
                  <GrValidate />
                </Button>
                <Button
                  variant="danger"
                  onClick={() =>
                    updateOnTrue(
                      "cours",
                      item?.id,
                      "isArchived",
                      "Rejetté avec succès"
                    ).then(
                      forNotification(
                        `Le cours dont le titre est ${item?.titre_cours} a été rejetté merci de l'ameliorer et de l'envoyer a nouveau`,
                        item?.created_by
                      )
                    )
                  }
                  className='text-white'
                >
                  <ImBlocked />
                </Button>
              </>
            ) : item?.created_by === currentUserData.id ? (
              <>
                <Link to={`${MODIFIER_COURS_NAVIGATION}${item?.id}`}>
                  <Button variant="primary"><RiEdit2Fill /></Button>
                </Link>{" "}
                <Button
                  onClick={() => {
                    deleteElement("cours", item?.id);
                  }}
                  variant="danger"
                >
                 <AiFillDelete />
                </Button>
              </>
            ) : (
              <Button
                variant="secondary"
                onClick={() =>
                  updateOnFalse(
                    "cours",
                    item?.id,
                    "isApproved",
                    "Désapprouvé avec succès"
                  )
                }
              >
                <TiArrowSync />
              </Button>
            )}
          </>
        ) : currentUserData?.user_type === "prof" ? (
          <>
            <Link to={`${MODIFIER_COURS_NAVIGATION}${item?.id}`}>
              <Button variant="primary"><RiEdit2Fill /></Button>
            </Link>{" "}
            <Button
              onClick={() => {
                deleteElement("cours", item?.id);
              }}
              variant="danger"
            >
             <AiFillDelete />
            </Button>
          </>
        ) : null}
       
          <Link to={`${INFO_COURS}/${item?.id}`}>
            <Button className="btn text-white fw-bold"  variant="info"><BsFillPlayBtnFill /></Button>
          </Link>
      </td>
    </tr>
  );
}

export default ListCourses;
